module.exports = __webpack_public_path__ + "frontend/images/homepage/slider/card-3.jpg?ed9706bd28307643eafb766100abc72a";